<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Meal Type</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Meal Type</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">Delete Meal Type</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onToggle()">
			{{ ToggleText }}
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstMeal"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedMeal"
		dataKey="MealID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--MealName-->
				<th>
					<p-columnFilter type="text" field="MealName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StartTime-->
				<th>
					<p-columnFilter type="text" field="StartTime" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--EndTime-->
				<th>
					<p-columnFilter type="text" field="EndTime" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--MealPrice-->
				<th>
					<p-columnFilter type="text" field="MealPrice" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--UsedByDesc-->
				<th>
					<p-columnFilter field="UsedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterUsedByDesc
								[ngModel]="value"
								[options]="lstUsedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="MealName">Name<p-sortIcon field="MealName"></p-sortIcon></th>
				<th pSortableColumn="StartTime">Start Time<p-sortIcon field="StartTime"></p-sortIcon></th>
				<th pSortableColumn="EndTime">End Time<p-sortIcon field="EndTime"></p-sortIcon></th>
				<th pSortableColumn="MealPrice">Price<p-sortIcon field="MealPrice"></p-sortIcon></th>
				<th pSortableColumn="UsedByDesc">Used By<p-sortIcon field="UsedByDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Meal>
			<tr [pSelectableRow]="Meal" (dblclick)="onRowDblClick(Meal)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Meal[col.field] }}
				</td>

				<td style="font-weight: bold" [style.color]="Meal.Active == true ? 'Black' : 'Red'">
					{{ Meal["ActiveDesc"] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
